import useAdBlockStore from "store/AdBlockStore";
import { Typography, Card, Badge, Empty, Space } from "antd";
import {
  OFFER_SUGGESTION_TITLE,
  INCENTIVE_SUGGESTION_TITLE,
  OFFER_INIT_SUGGESTIONS,
  OFFER_INIT_INFO,
  INCENTIVE_INIT_SUGGESTION,
  INCENTIVE_INIT_INFO,
  INCENTIVE_INFO_FIELDS,
  OFFER_INFO_FIELDS,
  INIT_OFFER_METADATA,
  EXTRA_INCENTIVE_SUGGESTIONS,
} from "config";
import { AdblockApproved } from "components";

const { Title, Text } = Typography;

const styles = {
  panel: {
    border: '1px solid transparent',
  },
  panelBody: {
    padding: '8px',
  },
  title: {
    color: '#ffffff',
    marginBottom: '16px',
    fontSize: '14px',
    fontWeight: '600'
  },
  suggestionCard: {
    backgroundColor: '#2a2a2a',
    borderRadius: '6px',
    cursor: 'pointer'
  },
  suggestionCardBody: {
    padding: '12px',
    display: 'flex',
    alignItems: 'center',
  },
  badge: {
    backgroundColor: '#595959',
    color: '#ffffff',
    fontSize: '10px',
    minWidth: '20px',
    height: '20px',
    lineHeight: '20px',
    marginRight: '12px'
  },
  itemText: {
    color: '#ffffff',
    fontWeight: '500',
    fontSize: '13px'
  },
  emptyText: {
    color: '#8c8c8c',
    fontSize: '13px'
  },
  emptyContainer: {
    margin: '24px 0'
  },
  noSuggestionsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    padding: '24px'
  }
};

const SuggestionItem = ({ index, text, onClick }) => (
  <Card
    size="small"
    className="suggestion-item"
    hoverable
    style={styles.suggestionCard}
    styles={{ body: styles.suggestionCardBody }}
    onClick={onClick}
  >
    <Badge count={index + 1} style={styles.badge} />
    <Text style={styles.itemText}>{text}</Text>
  </Card>
);

const EmptyState = ({ text }) => (
  <Empty
    description={<Text style={styles.emptyText}>{text}</Text>}
    image={Empty.PRESENTED_IMAGE_SIMPLE}
    style={styles.emptyContainer}
  />
);

const SuggestionsPanel = () => {
  const currentOffer = useAdBlockStore((state) => state.currentOffer);
  const currentSuggestions = useAdBlockStore((state) => state.currentSuggestions);
  const activeBlockData = useAdBlockStore(state => state.activeBlockData);
  const activeField = useAdBlockStore((state) => state.activeField);
  const updateCurrentOffer = useAdBlockStore((state) => state.updateCurrentOffer);
  const focusNextField = useAdBlockStore((state) => state.focusNextField);

  function handleTabNext(event) {
    event.preventDefault();
    const focusableElements = document.getElementById("offer-builder")?.querySelectorAll(
      'input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [role="combobox"]:not([disabled]), [role="checkbox"]:not([disabled])'
    );
    const elementsArray = Array.from(focusableElements || []);
    const currentIndex = elementsArray.indexOf(document.activeElement);
    const nextElement = elementsArray[currentIndex + 1] || elementsArray[0];
    nextElement?.focus();
  }

  const getConfig = () => {
    console.log('getConfig activeField0', activeField)
    switch (activeField) {
      case 'offer_type':
        return {
          title: 'Offer Type Suggestions',
          items: currentSuggestions?.offers || [],
          getKey: (item) => item.id,
          getText: (item) => item.offer_type,
          emptyText: 'No Offer type suggestions available',
          onSelect: (item) => {
            updateCurrentOffer({
              offer_type: item.offer_type
            });
          }
        };
      case 'incentive_type':
        return {
          title: 'Incentive Type Suggestions',
          items: EXTRA_INCENTIVE_SUGGESTIONS[currentOffer?.incentive_type] || [],
          getKey: (item) => item.value,
          getText: (item) => item.title,
          emptyText: 'No Incentive type suggestions available',
          onSelect: (item) => {
            updateCurrentOffer({
              incentive_text: item.value
            });
          }
        };
    }
  };

  const config = getConfig();
  console.log("CONFIG", config)

  if (activeBlockData.offers_approved) {
    return <AdblockApproved />
  }

  if (!config) {
    return (
      <div style={styles.noSuggestionsContainer}>
        <EmptyState text="No suggestions available for this element." />
      </div>
    );
  }

  return (
    <Card
      className="offer-left-panel"
      style={styles.panel}
      styles={{ body: styles.panelBody }}
    >
      <Title level={5} style={styles.title}>
        {config.title}
      </Title>

      {
        config.items.length > 0 ? (
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            {config.items.map((item, index) => (
              <SuggestionItem
                key={config.getKey(item) || index}
                index={index}
                text={config.getText(item)}
                onClick={(event) => {
                  if (config.onSelect) {
                    config.onSelect(item);
                  } else {
                    updateCurrentOffer((offer) => ({
                      ...offer,
                      [activeField]: config.getKey(item)
                    }));
                  }
                  focusNextField("offer-builder", event);
                }}
              />
            ))}
          </Space>
        ) : (
          <EmptyState text={config.emptyText} />
        )
      }
    </Card >
  );
}


export default SuggestionsPanel;